<template>
  <RecipBlockList />
</template>
<script>
// @ is an alias to /src
import RecipBlockList from "@/components/RecipBlockList.vue";

export default {
  name: "BlockListView",
  components: {
    RecipBlockList,
  },
};
</script>